import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { StorySection } from '../components/StorySection';
import { DesireSection } from '../components/DesireSection';
import { ProductSection } from '../components/ProductSection';
import { PricingSection } from '../components/PricingSection';
import { ValueSection } from '../components/ValueSection';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-175">
      <Hero data-id="element-176" />
      <ProblemSection data-id="element-177" />
      <SolutionSection data-id="element-178" />
      <StorySection data-id="element-179" />
      <DesireSection data-id="element-180" />
      <ProductSection data-id="element-181" />
      <PricingSection data-id="element-182" />
      <ValueSection data-id="element-183" />
      <FinalCTA data-id="element-184" />
    </div>;
}